"use client";

import {
  BlurBackgroundContainer,
  type BlurBackgroundContainerProps,
} from "@/component/BlurBackgroundContainer";
import { useMediaPreviewContext } from "../context";
import { MediaPreviewActions } from "./MediaPreviewActions";

interface MediaPreviewContentProps {
  videoPlayerRef?: BlurBackgroundContainerProps["videoPlayerRef"];
}

export function MediaPreviewContent({
  videoPlayerRef,
}: MediaPreviewContentProps) {
  const { mediaType, current } = useMediaPreviewContext();

  return (
    <>
      <BlurBackgroundContainer
        mediaType={mediaType === "image" ? "image" : "video"}
        src={current.src}
        previewSrc={current.previewSrc}
        height="100%"
        alt="preview"
        className="w-full h-full"
        videoPlayerRef={videoPlayerRef}
      />

      <MediaPreviewActions />
    </>
  );
}
